import { createSlice } from "@reduxjs/toolkit";
import policyEditorState from "./policy-editor-state";
import policyEditorReducers from "./policy-editor-reducers";

const policyEditorSlice = createSlice({
  name: "policyEditor",
  initialState: policyEditorState,
  reducers: policyEditorReducers,
});

export const policyEditorActions = policyEditorSlice.actions;

export default policyEditorSlice;
